import script from "./ROIInsights.vue?vue&type=script&setup=true&lang=js"
export * from "./ROIInsights.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./ROIInsights.vue?vue&type=style&index=1&id=583585e9&lang=css"

const __exports__ = script;

export default __exports__